import React from 'react';
import { FC, useCallback, useState } from 'react';

import { Button, Label } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { shareApi } from 'client/api';
import { useFetchingHandler } from 'client/hooks/useFetchingHandler';
import { InstallableApp, Skill } from 'client/model/skill';
import * as keyset from 'i18n/Access';

import { Field } from '../form/Field/Field';
import { TextInputWithCopy } from '../form/TextInputWithCopy/TextInputWithCopy';

import styles from './SharingPage.module.scss';

const t = i18n(keyset);

interface Props {
    aliceApp: InstallableApp | Skill;
    sharingAvailable?: boolean;
}

export const SharingPageGenerateLink: FC<Props> = ({ aliceApp, sharingAvailable }) => {
    const [oneTimeLink, setOneTimeLink] = useState('');

    const [createOneTimeShare, generationState] = useFetchingHandler({
        handler: shareApi.createOneTimeShare,
        throwErrors: true,
    });

    const generateOneTimeLink = useCallback(async () => {
        try {
            const oneTimeShareKey = await createOneTimeShare({ skillId: aliceApp.id }, aliceApp.channel);

            const shareLink = `${__appConfig.app.shareBaseUrl}?key=${oneTimeShareKey}`;

            setOneTimeLink(shareLink);
        } catch (e) {
            console.error(e);
        }
    }, [aliceApp.id, aliceApp.channel, createOneTimeShare]);

    const isGenerating = generationState === 'loading';
    const isError = generationState === 'error';

    return (
        <Field
            fieldTitle={t('links-header')}
            fieldDescription={t('app-link-description')}
            error={isError ? t('error') : undefined}
        >
            <TextInputWithCopy value={oneTimeLink} disabled={isGenerating} />
            <Button onClick={generateOneTimeLink} loading={isGenerating} size="l" disabled={!sharingAvailable}>
                {t('links-button-generate')}
            </Button>
            {sharingAvailable === false ? (
                <Label className={styles.sharingWarning} theme="warning" size="s">
                    {t('max-number-reached')}
                </Label>
            ) : null}
        </Field>
    );
};
